import { FlexRow, MaterialIcon, VerticalDivider } from '@gorila-shared-ui/components';
import { Card } from 'baseui/card';
import { HeadingSmall, HeadingXSmall } from 'baseui/typography';
import { memo } from 'react';
import { generatePath } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { LIVE_STATUS_PAGE } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { apiParamsState } from '../../storage/app';
import { LiveStatusIdentifier } from '../../types/liveStatus';

type Props = {
  title: string;
  quantity: number;
  percentage: number;
  universe: number;
  identifier: LiveStatusIdentifier;
};
function LiveStatusCard({ title, quantity, percentage, universe, identifier }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const apiParams = useRecoilValue(apiParamsState);

  return (
    <Card
      overrides={{
        Root: {
          style: {
            borderLeftWidth: '1px',
            borderRightWidth: '1px',
            borderTopWidth: '1px',
            borderBottomWidth: '1px',
            userSelect: 'none',
            flexShrink: 0,
            backgroundColor: theme.colors.backgroundPrimary,
            cursor: 'default',
            ':hover': {
              cursor: 'pointer',
              backgroundColor: theme.colors.backgroundSecondary,
            },
          },
        },
        Body: {
          style: {
            marginBottom: 0,
          },
        },
      }}
    >
      <div
        className={`${css({
          gap: theme.sizing.scale300,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        })}`}
        onClick={() =>
          apiParams &&
          identifier &&
          window.open(
            generatePath(LIVE_STATUS_PAGE.route, { id: apiParams.subClientId, identifier: identifier }),
            '_blank',
            'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no, height=700px, width=1400px',
          )
        }
      >
        <FlexRow
          gap={theme.sizing.scale800}
          classNames={css({ alignItems: 'center', width: '100%' })}
        >
          <div className={css({ flex: 1, textAlign: 'end' })}>
            <HeadingSmall
              margin={0}
              color={theme.colors.contentTertiary}
              display="inline-flex"
              alignItems="center"
              gridGap={theme.sizing.scale100}
            >
              {quantity}
              <span className={css({ fontSize: theme.sizing.scale700 })}>/</span>
              {universe}
            </HeadingSmall>
          </div>
          <VerticalDivider
            height={30}
            width={2}
            classNames={css({ background: theme.colors.backgroundTertiary + ' !important' })}
          />
          <FlexRow
            gap={theme.sizing.scale0}
            classNames={css({ flex: 1, alignItems: 'center' })}
          >
            <HeadingSmall
              margin={0}
              color={theme.colors.contentTertiary}
            >
              {percentage}
            </HeadingSmall>
            <MaterialIcon
              name="percent"
              size={theme.typography.HeadingSmall.fontSize}
              color={theme.colors.contentTertiary}
            />
          </FlexRow>
        </FlexRow>
        <HeadingXSmall
          margin={0}
          className={css({
            textAlign: 'center',
          })}
        >
          {title}
        </HeadingXSmall>
      </div>
    </Card>
  );
}

export default memo(LiveStatusCard);
